import { styled } from 'ui/styles'

export const Name = styled.div`
  font-size: ${(props) => props.theme.typography.h10.fontSize};
  font-weight: 700;
  line-height: ${(props) => props.theme.typography.h10.lineHeight};
`
